import { Supplier, SupplierActionsList, SupplierSampleData } from "../actions/supplierActions";
import { Action } from "../actions/types";


export const supplierReducer = (state: Supplier[] = SupplierSampleData, action: Action) => {

    switch (action.type) {

        case SupplierActionsList.ADD_SUPPLIER: {

            return [...state, action.data]
        }

        case SupplierActionsList.EDIT_SUPPLIER: {

            const index = state.findIndex(i => i.id === action.id)
            const newState = [...state]

            if (index > -1) {
                newState[index] = {
                    ...action.data,
                    id: action.id
                }
            }
            return newState
        }

        case SupplierActionsList.FETCH_SUPPLIER: {

            return state
        }

        case SupplierActionsList.DELETE_SUPPLIER: {
            return state.filter(i => i.id !== action.data.id)

        }

        default: return state
    }

}